<template>
	<main class="founder-page">
		<section class="founder-profile">
			<div class="founder-photo">
				<img
					src="https://oss.cuttlefish.vip/file/h5upload/178884597192817047704.png"
					alt="墨鱼旅行创始人马丽萍"
				/>
			</div>
			<div class="founder-summary">
				<span class="english-title">FOUNDER STORY</span>
				<h1>马丽萍</h1>
				<div class="founder-role">墨鱼旅行创始人兼CEO</div>
				<div class="founder-honors">
					<strong>长江商学院FMBA / EMBA / VC Start</strong>
					<span>2021年入选《胡润U30中国创业领袖》</span>
					<span>2025年入选《胡润U40中国创业先锋》</span>
				</div>
				<p>
					马丽萍，墨鱼旅行创始人兼CEO，长江商学院FMBA及VC STAR项目校友；2021年、2025年分别入选《胡润U30中国创业领袖》与《胡润U40中国创业先锋》榜单。她是一位连续创业者与深度旅行探索者，个人足迹覆盖全球超过80个国家和地区。基于对<strong>“和谁去，比去哪里更重要”</strong>这一核心社会洞察，她于2018年创立墨鱼旅行，开创<strong>“社交+旅行”</strong>新赛道，推动平台从线上旅行社交向<strong>“线上AI智能匹配+线下同频社交体验”</strong>双轮驱动升级，致力于打造全球最大的旅行社交平台，解决现代人在数字化时代的旅行孤独感，帮助用户找到价值观契合、兴趣同频的旅伴。该公司成立于2018年，平台面向对旅行品质、圈层氛围和深度体验有要求的用户，通过出发地、年龄、兴趣、旅行风格等多维度智能匹配，帮用户找到同频旅行搭子，并围绕圈层同频与兴趣同频提供主题行程、组队出发。
				</p>
				<p>
					同时，墨鱼旅行搭建“全球队长”生态，由专业领队、兴趣达人、在地玩家、KOL等认证队长带玩，为用户提供特色化的旅行服务。交易上采用资金托管模式：用户付款先由平台保管，行程结束并确认体验后，再向队长结算，用机制降低陌生人结伴的信任成本，让“找搭子—组队—出行—履约”形成安全闭环。
				</p>
			</div>
		</section>

		<article class="founder-content">
			<section>
				<h3>一、创业历程</h3>
				<p>
					创业初期，墨鱼旅行实现了跨越式发展：连续完成A轮和A+轮累计<strong>4亿元融资</strong>，资本加持助力平台生态快速扩张。至2025年，平台已实现稳定盈利，并持续拓展旅行产品、旅行搭子匹配及线下社交体验等业务场景。2026年：提出<strong>“线上AI匹配+线下同频组队”</strong>的战略，落地多家线下“搭子碰头处”体验店，启动<strong>“三年万店计划”</strong>与全国城市合伙人招募，推动社交旅行从线上App走向线下实体网络。
				</p>
			</section>

			<section>
				<h3>二、行业创新</h3>
				<p>
					马丽萍长期关注旅行与社交场景的结合，并围绕年轻用户的社交旅行需求开展产品探索。她率先突破传统在线旅游（OTA）“以产品供应链为中心”的思维定式，创造性提出<strong>“以人为中心，社交驱动旅行”</strong>的旅行4.0理念。她将墨鱼旅行定位为新一代社交旅行平台，其创新性体现在：
				</p>
				<div class="innovation-list">
					<p><strong>价值重构：</strong>将交易核心从“机票酒店景点”的简单组合，转向“人与人的连接”和“共同经历的创造”。</p>
					<p><strong>产品创新：</strong>主导推出“找搭子”核心功能，利用算法匹配与兴趣社区，构建“行前匹配-行中共创-行后沉淀”的完整社交旅行闭环。</p>
					<p><strong>生态构建：</strong>建立“墨鱼队长”体系，赋能全球旅行达人、本地生活家成为旅行产品创作者，打造了一个去中心化、充满活力的旅行体验供给生态。</p>
					<p><strong>业态延伸：</strong>2026年把线上流量导入3×5㎡标准化线下店（1天快装、不囤货不垫资、单人可运营），用S2b2c模型重构旅行社门店，避开传统门市“卖线路差价”的内卷逻辑。</p>
				</div>
			</section>

			<section>
				<h3>三、荣誉奖项</h3>
				<div class="award-list">
					<div><strong>2021年</strong><span>入选《2021胡润U30中国创业领袖》榜单。</span></div>
					<div><strong>2025年</strong><span>入选《2025胡润U40中国创业先锋》，其创业实践及企业发展受到行业关注。</span></div>
				</div>
			</section>

			<section>
				<h2>社会活动</h2>
				<p>
					马丽萍积极投身于行业建设与公益实践。她曾参与“中国成功青年创业领袖共话”等相关活动。分享关于旅游产业变革、创业管理的洞见。在企业管理中，她将企业社会责任（CSR）理念深度融入公司文化，注重员工关怀、职业发展与团队福祉，并鼓励团队参与社区服务与公益项目，践行社会价值。
				</p>
			</section>
		</article>
	</main>
</template>

<script>
	export default {
		name: "FounderIntro",
	};
</script>

<style scoped lang="scss">
	.founder-page {
		box-sizing: border-box;
		padding: 48px 24px 80px;
		background:
			radial-gradient(circle at 8% 4%, rgba(232, 106, 43, 0.1), transparent 24%),
			#f7f8fa;
		color: #444;
	}

	.founder-profile,
	.founder-content {
		margin: 0 auto;
		max-width: 1200px;
		border-radius: 22px;
		background: #fff;
		box-shadow: 0 18px 50px rgba(67, 53, 43, 0.1);
	}

	.founder-profile {
		display: flex;
		overflow: hidden;
		min-height: 650px;

		.founder-photo {
			flex: 0 0 44%;
			overflow: hidden;
			background: linear-gradient(180deg, #fff8f0 0%, #f4d3b5 100%);

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center 10%;
			}
		}

		.founder-summary {
			display: flex;
			flex: 1;
			flex-direction: column;
			justify-content: center;
			box-sizing: border-box;
			padding: 54px 58px;

			.english-title {
				font-size: 13px;
				font-weight: 700;
				color: #e86a2b;
				letter-spacing: 4px;
			}

			h1 {
				margin: 12px 0 4px;
				font-size: 42px;
				color: #25211e;
			}

			.founder-role {
				margin-bottom: 24px;
				font-size: 18px;
				font-weight: 700;
				color: #e86a2b;
			}

			.founder-honors {
				display: flex;
				flex-direction: column;
				gap: 8px;
				margin-bottom: 26px;
				padding: 18px 20px;
				border-left: 4px solid #e86a2b;
				background: #fff7f1;
				font-size: 14px;
				line-height: 1.6;
				color: #795640;
			}

			p {
				margin: 0;
				font-size: 16px;
				line-height: 2;
				text-align: justify;
			}

			strong {
				font-weight: 700;
				color: #2b2724;
			}
		}
	}

	.founder-content {
		box-sizing: border-box;
		margin-top: 36px;
		padding: 56px 70px;

		section {
			margin-top: 48px;

			&:first-child {
				margin-top: 0;
			}
		}

		h2 {
			position: relative;
			margin: 0 0 28px;
			padding-left: 18px;
			font-size: 28px;
			color: #292420;

			&::before {
				position: absolute;
				top: 4px;
				left: 0;
				width: 5px;
				height: 30px;
				border-radius: 3px;
				background: #e86a2b;
				content: "";
			}
		}

		h3 {
			margin: 0 0 18px;
			font-size: 21px;
			color: #332c27;
		}

		p {
			margin: 0 0 18px;
			font-size: 16px;
			line-height: 2;
			text-align: justify;

			&:last-child {
				margin-bottom: 0;
			}
		}

		strong {
			font-weight: 700;
			color: #292420;
		}
	}

	.innovation-list {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 18px;
		margin-top: 26px;

		p {
			margin: 0;
			padding: 22px;
			border: 1px solid #f0e5dd;
			border-radius: 12px;
			background: #fffaf6;
			font-size: 15px;
			line-height: 1.9;
		}
	}

	.award-list {
		display: flex;
		flex-direction: column;
		gap: 14px;

		div {
			display: grid;
			grid-template-columns: 90px 1fr;
			padding: 16px 20px;
			border-radius: 10px;
			background: #f8f9fa;
			font-size: 16px;
			line-height: 1.7;

			strong {
				color: #e86a2b;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.founder-page {
			padding: 20px 14px 48px;
		}

		.founder-profile {
			flex-direction: column;
			min-height: 0;
			border-radius: 16px;

			.founder-photo {
				flex: none;
				height: 460px;
			}

			.founder-summary {
				padding: 34px 22px 38px;

				h1 {
					font-size: 34px;
				}

				p {
					font-size: 15px;
					line-height: 1.9;
				}
			}
		}

		.founder-content {
			margin-top: 18px;
			padding: 36px 20px;
			border-radius: 14px;

			section {
				margin-top: 40px;
			}

			h2 {
				font-size: 24px;
			}

			h3 {
				font-size: 19px;
			}

			p {
				font-size: 15px;
				line-height: 1.9;
			}
		}

		.innovation-list {
			grid-template-columns: 1fr;
		}

		.award-list div {
			display: block;

			strong {
				display: block;
				margin-bottom: 4px;
			}
		}
	}
</style>
